import { Injectable } from '@angular/core';
import { catchError, map, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { FavPageViewModel } from '../models/home/fav-page.model';
import { ApiEnum, HttpDataService } from './http-data.service';

@Injectable({
    providedIn: 'root'
})
export class SettingsService {

    constructor(private readonly httpDataService: HttpDataService) {
    }

    favService(service: string): any {
        return this.httpDataService.post$<string[]>(ApiEnum.API_ROOT, `${environment.endpoint.settings.fav  }/${  service}`, null)
            .pipe(
                map((result) => {
                    return result;
                }),
                retry(3),
                catchError(this.httpDataService.handleError<string[]>('favService'))
            );
    }

    unfavService(service: string): any {
        return this.httpDataService.delete$<string[]>(ApiEnum.API_ROOT, `${environment.endpoint.settings.unfav  }/${  service}`, null)
            .pipe(
                map((result) => {
                    return result;
                }),
                retry(3),
                catchError(this.httpDataService.handleError<string[]>('unfavService'))
            );
    }

    getFavPages(): any {
        return this.httpDataService.get$<FavPageViewModel[]>(ApiEnum.API_ROOT, environment.endpoint.settings.favPages, null)
            .pipe(
                map((result) => {
                    return result;
                }),
                retry(3),
                catchError(this.httpDataService.handleError<FavPageViewModel[]>('favPages'))
            );
    }

    favPage(name: string, location: string, url: string): any {
        const favPage = {
            name,
            location,
            url
        }
        return this.httpDataService.post$<FavPageViewModel[]>(ApiEnum.API_ROOT, environment.endpoint.settings.favPage, favPage )
            .pipe(
                map((result) => {
                    return result;
                }),
                retry(3),
                catchError(this.httpDataService.handleError<FavPageViewModel[]>('favPage'))
            );
    }

    unfavPage(name: string, location: string, url: string): any {
        const favPage = {
            name,
            location,
            url
        }
        return this.httpDataService.post$<FavPageViewModel[]>(ApiEnum.API_ROOT, environment.endpoint.settings.unfavPage, favPage)
            .pipe(
                map((result) => {
                    return result;
                }),
                retry(3),
                catchError(this.httpDataService.handleError<FavPageViewModel[]>('unfavPage'))
            );
    }
    
    isAdmin(): any {
        return this.httpDataService.get$<boolean[]>(ApiEnum.API_ROOT, environment.endpoint.settings.isAdmin, null)
            .pipe(
                map((result) => {
                    return result;
                }),
                retry(3),
                catchError(this.httpDataService.handleError<boolean[]>('isAdmin'))
            );
    }
}